"use client";
import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading, } from "../../../store/loading/loading.slice";
import { RootState } from "../../../store/store";
import { ImageContent } from "../../../assets/background/background";
import clsx from "clsx";
import { BANNER_TYPE } from "../../cms-website/website-structure/content/enum/content.enum";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import {
    Box,
    Divider,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import ContainerButton from "../../../components/button/ContainerButton";
import HtmlRenderer from "../../../components/render-html/RenderHtml";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { decode } from "html-entities";
import { useNavigate, useParams } from "react-router-dom";
import { FrontApi } from "../../../api/front-api/front.api";
import { routeName } from "../../../routes/routeName";
import { alertError } from "../../../components/alert/swal";
import BannerSlide from "../../../components/banner-slide/BannerSlide";
import { useTranslation } from "react-i18next";


type Props = {};
const chunkArray = (array: any[], size: number) => {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
        array.slice(index * size, index * size + size)
    );
};

const ContentDetail: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const { content_no } = useParams();
    const navigate = useNavigate();
    const theme = useTheme();
    const mode = theme.palette.mode;
    const dispatch = useDispatch();
    // const [searchParams] = useSearchParams();
    const baseApi = useSelector((state: RootState) => state.api.image_api);
    // const baseApi_content = useSelector(
    //     (state: RootState) => state.api.public_content_api
    // );
    // const current_path = location.pathname


    const matches = useMediaQuery(theme.breakpoints.down("lg"));
    const nextRef = useRef<HTMLDivElement>(null);
    const preRef = useRef<HTMLDivElement>(null);

    const [warning_detail, set_warning_detail] = useState<any>(null);
    const [banner_type, set_banner_type] = useState<string>("");
    const [media_file, set_media_file] = useState<any[]>([]);
    const [banner_slide_data, set_banner_slide_data] = useState<any[]>([]);

    const handleInit = (swiper: any) => {
        if (preRef.current && nextRef.current) {
            swiper.params.navigation.prevEl = preRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
        }
    };

    const handleGetContentDetail = async (content_no: string) => {
        dispatch(setLoading());
        await FrontApi.findOneByContentNo(content_no)
            .then((res) => {
                if (res.status < 300) {
                    const content_files: any[] = res.data?.data?.content_files || [];
                    if (content_files?.length > 0) {
                        const map_content_file = content_files?.map((list) => ({ ...list, ...list?.media_file }))
                        set_banner_slide_data(map_content_file);
                    }
                    set_warning_detail(res.data?.data || null);
                    set_banner_type(res.data?.data?.banner_type || "");
                    const media_file = Array.isArray(res.data?.data?.media_file)
                        ? res.data?.data?.media_file
                        : [];
                    set_media_file(media_file);
                }
            })
            .catch((err) => {
                alertError(t("เกิดข้อผิดพลาด"), err?.response?.data?.message || "-");
                navigate(-1);
                return;
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    };

    const isHTMLString = (str: string): boolean => {
        const htmlRegex = /<\/?[a-z][\s\S]*>/i;
        return htmlRegex.test(str);
    };

    const isHTML = isHTMLString(warning_detail?.content_name ?? "");

    // function fixBrokenHtml(input: string): string {
    //   let output = input;

    //   // 1. แก้ quote ผิด เช่น ” → "
    //   output = output.replace(/[“”]/g, '"').replace(/[‘’]/g, "'");

    //   // 2. แปลง /tag → </tag>
    //   output = output.replace(/\/([a-z][a-z0-9]*)\b/gi, (_, tag) => `</${tag}>`);

    //   // 3. ตรวจหา tag <img ...> ที่ไม่มี < > และ wrap ให้ถูกต้อง
    //   output = output.replace(/img\s+([^<>]+?)\s+(?=src=)/gi, (_match, attrs) => {
    //     return `<img ${attrs.trim()} `;
    //   });

    //   // 4. แปลงกรณีที่ tag img ยังไม่ปิดให้เป็น self-closing
    //   output = output.replace(/<img([^>]*)(?!\/)>?/gi, '<img$1 />');

    //   // 5. เพิ่ม <p> ครอบข้อความที่อยู่หน้าตรงๆ (ถ้าไม่มี tag เปิด)
    //   output = output.replace(/^([^<]+)/, (_, text) => `<p>${text.trim()}</p>`);

    //   return output;
    // }
    const content_detail_html = decode(
        warning_detail?.content_detail || ""
    ).replace(/”/g, '"'); // แก้ quote

    useEffect(() => {
        window.scrollTo({ top: 2, behavior: "smooth" });
        if (!content_no) {
            navigate("/404");
        } else {
            handleGetContentDetail(content_no);
        }
    }, [content_no]);

    const chunks: any[] = chunkArray(media_file?.length > 0 ? media_file : [], 4);
    // console.log(chunks, 'chunks')

    return (
        <>
            <BannerSlide
                banner_type={banner_type as BANNER_TYPE}
                banner_slide={banner_slide_data || []}
            />
            <Box
                sx={{
                    backgroundColor: mode === "dark" ? "black" : "white",
                }}
                component={"main"}
                className="w-full py-2 px-10 md:px-[100px] md:py-3"
            >
                {warning_detail?.content_name && (
                    <section>
                        <Typography
                            sx={{
                                color: (theme) => theme.palette.text.primary,
                                my: 4,
                                textAlign: "center",
                            }}
                            variant="h4"
                        >
                            {warning_detail?.content_name || "-"}
                        </Typography>

                        {warning_detail?.content_desc && (
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 4,
                                    textAlign: "center",
                                    fontSize: "14px",
                                    color: (theme) => theme.palette.text.primary,
                                }}
                            >
                                {warning_detail?.content_desc || "-"}
                            </Typography>
                        )}

                        <Divider />
                    </section>
                )}

                {chunks?.length !== 0 && banner_type !== BANNER_TYPE.TYPE_THREE && (
                    <>
                        <section className="w-full h-full mt-8">
                            <div
                                className={clsx(
                                    "grid grid-cols-12 gap-4 h-full lg:h-fit overflow-hidden",
                                    {
                                        hidden:
                                            banner_type === BANNER_TYPE.TYPE_FOUR ||
                                            banner_type === BANNER_TYPE.TYPE_THREE ||
                                            banner_type === BANNER_TYPE.TYPE_TWO,
                                    }
                                )}
                            >
                                <Box
                                    component={"span"}
                                    data-aos="fade-right"
                                    data-aos-offset="0"
                                    data-aos-easing="ease-in-sine"
                                    data-aos-anchor-placement="top-bottom"
                                    className={clsx(
                                        "h-full max-h-[500px] shadow-md rounded-2xl overflow-hidden",
                                        {
                                            "col-span-12 md:col-span-12 lg:col-span-6":
                                                banner_type === BANNER_TYPE.TYPE_TWO,
                                            // 'col-span-12 md:col-span-12 lg:col-span-8': banner_type === BANNER_TYPE.TYPE_THREE,
                                            "col-span-12": banner_type === BANNER_TYPE.TYPE_ONE,
                                        }
                                    )}
                                >
                                    {banner_type !== BANNER_TYPE.TYPE_ONE && (
                                        <>
                                            {media_file?.length > 0 ? (
                                                <img
                                                    className="w-full h-full object-cover"
                                                    src={`${baseApi}/${media_file[0]?.media_file_path}${media_file[0]?.media_file_name}`}
                                                    alt="image"
                                                />
                                            ) : (
                                                <img
                                                    className="w-full h-full object-cover"
                                                    src={ImageContent.noImage}
                                                    alt="noImage"
                                                />
                                            )}
                                        </>
                                    )}
                                    {banner_type === BANNER_TYPE.TYPE_ONE &&
                                        media_file?.length > 0 ? (
                                        <Swiper
                                            spaceBetween={30}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            modules={[Pagination]}
                                            className="type_one"
                                        >
                                            {media_file?.map((list, index) => {
                                                return (
                                                    <SwiperSlide key={list?.id_content}>
                                                        <img
                                                            className="w-full cursor-grab h-full object-cover"
                                                            src={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`}
                                                            alt={`image_${index}`}
                                                        />
                                                    </SwiperSlide>
                                                );
                                            })}
                                        </Swiper>
                                    ) : (
                                        <img
                                            className="w-full h-full object-cover"
                                            src={ImageContent.noImage}
                                            alt="noImage"
                                        />
                                    )}
                                </Box>
                                <Box
                                    component={"span"}
                                    data-aos="fade-right"
                                    data-aos-offset="0"
                                    data-aos-anchor-placement="top-bottom"
                                    data-aos-easing="ease-in-sine"
                                    className={clsx(
                                        "h-full max-h-[500px] rounded-2xl overflow-hidden",
                                        {
                                            "col-span-12 md:col-span-12 lg:col-span-3 ":
                                                banner_type === BANNER_TYPE.TYPE_TWO,
                                            hidden:
                                                banner_type === BANNER_TYPE.TYPE_THREE ||
                                                banner_type === BANNER_TYPE.TYPE_ONE,
                                        }
                                    )}
                                >
                                    {media_file?.length > 1 ? (
                                        <img
                                            className="w-full h-full object-cover"
                                            src={`${baseApi}/${media_file[1]?.media_file_path}${media_file[1]?.media_file_name}`}
                                            alt="image"
                                        />
                                    ) : (
                                        <img
                                            className="w-full h-full object-cover"
                                            src={ImageContent.noImage}
                                            alt="noImage"
                                        />
                                    )}
                                </Box>
                                <Box
                                    component={"span"}
                                    data-aos="fade-down"
                                    data-aos-easing="linear"
                                    data-aos-offset="0"
                                    data-aos-anchor-placement="top-bottom"
                                    data-aos-duration="600"
                                    className={clsx(
                                        "h-full  max-h-[500px] flex flex-row lg:flex-col ",
                                        {
                                            "col-span-12 gap-4 md:col-span-12 lg:col-span-3":
                                                banner_type === BANNER_TYPE.TYPE_TWO,
                                            "col-span-12 gap-4 md:col-span-12 lg:col-span-4":
                                                banner_type === BANNER_TYPE.TYPE_THREE,
                                            hidden: banner_type === BANNER_TYPE.TYPE_ONE,
                                        }
                                    )}
                                >
                                    <div
                                        className={clsx(
                                            "w-full h-full rounded-2xl overflow-hidden",
                                            {}
                                        )}
                                    >
                                        {media_file?.length > 2 ? (
                                            <img
                                                className="w-full h-full object-cover"
                                                src={`${baseApi}/${media_file[2]?.media_file_path}${media_file[2]?.media_file_name}`}
                                                alt="image"
                                            />
                                        ) : (
                                            <img
                                                className={clsx("w-full h-full object-cover")}
                                                src={ImageContent.noImage}
                                                alt="noImage"
                                            />
                                        )}
                                    </div>
                                    <div className="w-full h-full rounded-2xl overflow-hidden">
                                        {media_file?.length > 3 ? (
                                            <img
                                                className="w-full h-full object-cover"
                                                src={`${baseApi}/${media_file[3]?.media_file_path}${media_file[3]?.media_file_name}`}
                                                alt="image"
                                            />
                                        ) : (
                                            <img
                                                className="w-full h-full object-cover"
                                                src={ImageContent.noImage}
                                                alt="noImage"
                                            />
                                        )}
                                    </div>
                                </Box>
                            </div>
                        </section>

                        {/* TYPE 2 AND 3 */}
                        <section className="w-full h-full mt--">
                            <Swiper
                                spaceBetween={30}
                                pagination={{
                                    clickable: true,
                                }}
                                modules={[Pagination]}
                                className="type_one"
                                autoplay={{
                                    delay: 1000,
                                }}
                            >
                                {chunks?.length > 0 &&
                                    chunks?.map((chunk: any, main_index) => {
                                        return (
                                            <SwiperSlide key={main_index}>
                                                <div
                                                    className={clsx(
                                                        "grid grid-cols-12 gap-4 h-full lg:h-fit overflow-hidden",
                                                        {
                                                            hidden: !(
                                                                banner_type === BANNER_TYPE.TYPE_TWO ||
                                                                banner_type === BANNER_TYPE.TYPE_THREE
                                                            ),
                                                        }
                                                    )}
                                                >
                                                    <React.Fragment>
                                                        <Box
                                                            component={"span"}
                                                            data-aos="fade-right"
                                                            data-aos-offset="จ" /* i18n-ignore (non-visible AOS attribute) */
                                                            data-aos-easing="ease-in-sine"
                                                            data-aos-anchor-placement="top-bottom"
                                                            className={clsx(
                                                                "h-full max-h-[500px] shadow-md rounded-2xl overflow-hidden",
                                                                {
                                                                    "col-span-12 md:col-span-12 lg:col-span-6":
                                                                        banner_type === BANNER_TYPE.TYPE_TWO,
                                                                    "col-span-12 md:col-span-12 lg:col-span-8":
                                                                        banner_type === BANNER_TYPE.TYPE_THREE,
                                                                }
                                                            )}
                                                        >
                                                            {chunk[0]?.media_file_path ? (
                                                                <img
                                                                    className="w-full h-full object-cover"
                                                                    src={`${baseApi}/${chunk[0]?.media_file_path}${chunk[0]?.media_file_name}`}
                                                                    alt="image"
                                                                />
                                                            ) : (
                                                                <img
                                                                    className="w-full h-full object-cover"
                                                                    src={ImageContent.noImage}
                                                                    alt="noImage"
                                                                />
                                                            )}
                                                        </Box>
                                                        <Box
                                                            component={"span"}
                                                            data-aos="fade-right"
                                                            data-aos-offset="จ" /* i18n-ignore (non-visible AOS attribute) */
                                                            data-aos-anchor-placement="top-bottom"
                                                            data-aos-easing="ease-in-sine"
                                                            className={clsx(
                                                                "h-full max-h-[500px] rounded-2xl overflow-hidden",
                                                                {
                                                                    "col-span-12 md:col-span-12 lg:col-span-3 ":
                                                                        banner_type === BANNER_TYPE.TYPE_TWO,
                                                                    hidden:
                                                                        banner_type === BANNER_TYPE.TYPE_THREE,
                                                                }
                                                            )}
                                                        >
                                                            {chunk[1]?.media_file_path ? (
                                                                <img
                                                                    className="w-full h-full object-cover"
                                                                    src={`${baseApi}/${chunk[1]?.media_file_path}${chunk[1]?.media_file_name}`}
                                                                    alt="image"
                                                                />
                                                            ) : (
                                                                <img
                                                                    className="w-full h-full object-cover"
                                                                    src={ImageContent.noImage}
                                                                    alt="noImage"
                                                                />
                                                            )}
                                                        </Box>
                                                        <Box
                                                            component={"span"}
                                                            data-aos="fade-down"
                                                            data-aos-easing="linear"
                                                            data-aos-offset="0"
                                                            data-aos-anchor-placement="top-bottom"
                                                            data-aos-duration="600"
                                                            className={clsx(
                                                                "h-full  max-h-[500px] flex flex-row lg:flex-col ",
                                                                {
                                                                    "col-span-12 gap-4 md:col-span-12 lg:col-span-3":
                                                                        banner_type === BANNER_TYPE.TYPE_TWO,
                                                                    "col-span-12 gap-4 md:col-span-12 lg:col-span-4":
                                                                        banner_type === BANNER_TYPE.TYPE_THREE,
                                                                    hidden:
                                                                        banner_type === BANNER_TYPE.TYPE_ONE ||
                                                                        banner_type === BANNER_TYPE.TYPE_THREE,
                                                                }
                                                            )}
                                                        >
                                                            <div
                                                                className={clsx(
                                                                    "w-full h-full rounded-2xl overflow-hidden",
                                                                    {}
                                                                )}
                                                            >
                                                                {chunk[2]?.media_file_path ? (
                                                                    <img
                                                                        className="w-full h-full object-cover"
                                                                        src={`${baseApi}/${chunk[2]?.media_file_path}${chunk[2]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        className={clsx(
                                                                            "w-full h-full object-cover"
                                                                        )}
                                                                        src={ImageContent.noImage}
                                                                        alt="noImage"
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="w-full h-full rounded-2xl overflow-hidden">
                                                                {chunk[3]?.media_file_path ? (
                                                                    <img
                                                                        className="w-full h-full object-cover"
                                                                        src={`${baseApi}/${chunk[3]?.media_file_path}${chunk[3]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        className="w-full h-full object-cover"
                                                                        src={ImageContent.noImage}
                                                                        alt="noImage"
                                                                    />
                                                                )}
                                                            </div>
                                                        </Box>
                                                        {/* {banner_type === BANNER_TYPE.TYPE_THREE && (
                                                        <Box component={'span'} data-aos="fade-down"
                                                            data-aos-easing="linear"
                                                            data-aos-offset="0"
                                                            data-aos-anchor-placement="top-bottom"
                                                            data-aos-duration="600" className={clsx('h-full  max-h-[500px] flex flex-row lg:flex-col ', {
                                                                'col-span-12 gap-4 md:col-span-12 lg:col-span-4': banner_type === BANNER_TYPE.TYPE_THREE,
                                                            })}>
                                                            <div className={clsx('w-full h-full rounded-2xl overflow-hidden', {
                                                            })}>
                                                                {chunk[1]?.media_file_path ? (
                                                                    <img className='w-full h-full object-cover'
                                                                        src={`${baseApi}/${chunk[1]?.media_file_path}${chunk[1]?.media_file_name}`}
                                                                        alt="image" />
                                                                ) : (
                                                                    <img className={clsx('w-full h-full object-cover')} src={ImageContent.noImage} alt="noImage" />
                                                                )}
                                                            </div>
                                                            <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                                {chunk[2]?.media_file_path ? (
                                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${chunk[2]?.media_file_path}${chunk[2]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                ) : (
                                                                    <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                                )}
                                                            </div>
                                                            <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                                {chunk[3]?.media_file_path ? (
                                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${chunk[3]?.media_file_path}${chunk[3]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                ) : (
                                                                    <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                                )}
                                                            </div>
                                                            <div className='w-full h-full rounded-2xl overflow-hidden'>
                                                                {chunk[4]?.media_file_path ? (
                                                                    <img className='w-full h-full object-cover' src={`${baseApi}/${chunk[4]?.media_file_path}${chunk[4]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                ) : (
                                                                    <img className='w-full h-full object-cover' src={ImageContent.noImage} alt="noImage" />
                                                                )}
                                                            </div>
                                                        </Box>
                                                    )} */}
                                                    </React.Fragment>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                            </Swiper>
                        </section>
                    </>
                )}

                <section className="grid grid-cols-12 gap-8">
                    <article
                        className={clsx("col-span-12 ", {
                            "md:col-span-8": banner_type === BANNER_TYPE.TYPE_THREE && media_file?.length !== 0,
                            "md:col-span-12": (banner_type === BANNER_TYPE.TYPE_THREE && media_file?.length === 0)
                        })}
                    >
                        <section className="w-full mt-4 md:mt-10 flex flex-col gap-2">
                            <article className="flex justify-between items-center">
                            </article>
                            {isHTML ? (
                                <HtmlRenderer html={warning_detail?.content_name} />
                            ) : (
                                <>{/*  */}</>
                            )}
                        </section>

                        <section className={clsx("w-full flex flex-col mt-0")}>
                            <HtmlRenderer html={content_detail_html} />
                        </section>

                        <ContainerButton
                            sxContainer={{ my: 10 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    key: "BACK",
                                    buttonProps: {
                                        sx: {
                                            borderRadius: "48px",
                                        },
                                        onClick: () => {
                                            if (window.history.length > 1) {
                                                navigate(-1)
                                            } else {
                                                navigate(routeName.main.home);
                                            }
                                        },
                                    },
                                    label: t("ย้อนกลับ"),
                                    type: "BACK",
                                },
                            ]}
                        />
                    </article>
                    {banner_type === BANNER_TYPE.TYPE_THREE && media_file?.length > 0 && (
                        <article className={clsx("relative col-span-4 h-screen", {})}>
                            <div
                                ref={preRef}
                                style={{
                                    backgroundColor: "#4A4A4A",
                                    color: "white",
                                }}
                                className={clsx(
                                    "absolute p-1 rounded-[50%] top-0 left-[50%] translate-x-[-50%] z-10 cursor-pointer",
                                    {
                                        hidden: matches,
                                    }
                                )}
                            >
                                <KeyboardArrowUpIcon />
                            </div>

                            <div
                                ref={nextRef}
                                style={{
                                    backgroundColor: "#4A4A4A",
                                    color: "white",
                                }}
                                className={clsx(
                                    "absolute p-1 rounded-[50%] bottom-0 left-[50%] translate-x-[-50%] z-10 cursor-pointer",
                                    {
                                        hidden: matches,
                                    }
                                )}
                            >
                                <KeyboardArrowDownIcon />
                            </div>
                            <Swiper
                                direction={matches ? "horizontal" : "vertical"}
                                pagination={{
                                    clickable: true,
                                }}
                                navigation={{
                                    nextEl: nextRef.current,
                                    prevEl: preRef.current,
                                }}
                                spaceBetween={10}
                                slidesPerView={matches ? 1 : 2}
                                modules={[Pagination, Navigation]}
                                className="mySwiper cursor-grab"
                                onInit={handleInit}
                            >
                                {media_file?.map((list, index) => {
                                    const id = `key_${index}`;
                                    return (
                                        <SwiperSlide
                                            style={{ overflow: "hidden" }}
                                            className="relative"
                                            key={id}
                                        >
                                            <div className="w-full h-fit border-4 border-white shadow-md">
                                                <img
                                                    className="object-cover"
                                                    width={"100%"}
                                                    src={`${baseApi}/${list?.media_file_path}${list?.media_file_name}`}
                                                    alt="image"
                                                />
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </article>
                    )}
                </section>
            </Box>
        </>
    );
};

export default ContentDetail;
